import { TourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';

/**
 * Zgody wyjazdu w roli listy dokumentów do ponownej akceptacji (krok W2).
 *
 * Backend nie wylicza, których zgód dotyczy dana paczka — bo nie ma czego
 * liczyć: wszystkie dokumenty są opcjonalne, a wskazuje je operator. Lista to
 * `GET /api/tour-consents/{tourId}` bez żadnego przetworzenia.
 */
export const tourConsentDocumentsMapper = {
  toDocuments(consents: TourConsentDto[]): AcceptanceDocumentVm[] {
    return consents.map((consent) => ({
      id: consent.id,
      name: consent.displayName,
      type: consent.type,
      required: consent.required,
    }));
  },

  /**
   * Identyfikatory zgód do `ResolveBookingChangeRequest.amendmentTourConsentIds`.
   *
   * Idzie dokładnie to, co operator zaznaczył — z pustym zaznaczeniem paczka
   * wchodzi bez ani jednego podpisu. Filtrowanie po liście zgód wyjazdu odsiewa
   * zaznaczenie sprzed przeładowania listy i porządkuje wynik.
   */
  toAmendmentConsentIds(
    consents: TourConsentDto[],
    selectedIds: string[],
  ): string[] {
    return consents
      .filter((consent) => selectedIds.includes(consent.id))
      .map((consent) => consent.id);
  },
};
